import {Box } from "@mui/material";

function Privacy() {
  return (
    <div>
        <Box marginLeft={80} marginTop={10} sx={{ maxWidth: 700 }}>
      <h1>Privacy and Policy</h1>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
        convallis facilisis enim, ac convallis sapien lobortis sed. Mauris
        mollis metus risus, eu condimentum sapien pulvinar ac. Curabitur purus
        ante, malesuada ut porta sit amet, interdum a diam. In posuere enim in
        eros eleifend feugiat. Fusce eu libero libero. Suspendisse sem velit,
        lobortis vel neque eget, viverra ultrices nisi. Morbi pellentesque
        tortor purus, id faucibus eros interdum in. Orci varius natoque
        penatibus et magnis dis parturient montes, nascetur ridiculus mus. Lorem
        ipsum dolor sit amet, consectetur adipiscing elit. Sed vel diam
        ultrices, condimentum eros vitae, aliquam eros. Curabitur in interdum
        orci.
      </p></Box>
    </div>
  );
}

export default Privacy;
